import { selectRegionalDistrictById, selectSelectedRegionalDistricts } from 'shared/selectors/geo';
import { addRegionalDistrict, removeRegionalDistrict } from 'shared/slices/geo';
import { TAsyncThunkAction } from 'shared/types/redux';
import { updateSearchMeta } from '../../searchMeta';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { addRegionalDistrictToJsonQuery, removeRegionalDistrictFromJsonQuery } from 'shared/utils/jsonQuery';
import { updateGeo } from 'shared/slices/jsonQuery';

export const selectRegionalDistrict =
  (id: number): TAsyncThunkAction =>
  async (dispatch, getState) => {
    const state = getState();
    const selectedDistricts = selectSelectedRegionalDistricts(state);
    const district = selectRegionalDistrictById(id)(state);
    const jsonQuery = selectJsonQuery(state);

    let newGeo;

    if (selectedDistricts.includes(id)) {
      dispatch(removeRegionalDistrict(district));

      newGeo = removeRegionalDistrictFromJsonQuery(jsonQuery, id);
    } else {
      dispatch(addRegionalDistrict(district));

      newGeo = addRegionalDistrictToJsonQuery(jsonQuery, id);
    }

    dispatch(updateGeo(newGeo));
    dispatch(updateSearchMeta());
  };
